export default {
	SERIA_AND_NUMBER_LENGTH: 9,
	CREDIT_CARD_NUMBER_LENGTH: 16
}